import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { PillarsSection } from "./components/PillarsSection";
import { IndustriesSection } from "./components/IndustriesSection";
import { ProofSection } from "./components/ProofSection";
import { AdvantageSection } from "./components/AdvantageSection";
import { SMEArchitectureSection } from "./components/SMEStackSection";
import { CTABlock } from "./components/CTABlock";
import { Footer } from "./components/Footer";
import PatientBillingPage from "./components/PatientBillingPage";
import ErpCrmPage from "./components/ErpCrmPage";
import DataSciencePage from "./components/DataSciencePage";
import IndustrySubPage from "./components/IndustrySubPage";
import ConsultationPage from "./components/ConsultationPage";
import AboutPage from "./components/AboutPage";
import CareersPage from "./components/CareersPage";
import PartnersPage from "./components/PartnersPage";
import PrivacyPage from "./components/PrivacyPage";
import { BlogListPage, BlogArticlePage } from "./components/BlogPages";

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <PillarsSection />
        <IndustriesSection />
        <ProofSection />
        <AdvantageSection />
        <SMEArchitectureSection />
        <CTABlock />
      </main>
      <Footer />
    </>
  );
};

const PatientBillingLayout = () => {
  return (
    <>
      <Header />
      <main>
        <PatientBillingPage />
      </main>
      <Footer />
    </>
  );
};

const ErpCrmLayout = () => {
  return (
    <>
      <Header />
      <main>
        <ErpCrmPage />
      </main>
      <Footer />
    </>
  );
};

const DataScienceLayout = () => {
  return (
    <>
      <Header />
      <main>
        <DataSciencePage />
      </main>
      <Footer />
    </>
  );
};

const AboutLayout = () => {
  return (
    <>
      <Header />
      <main>
        <AboutPage />
      </main>
      <Footer />
    </>
  );
};

const CareersLayout = () => {
  return (
    <>
      <Header />
      <main>
        <CareersPage />
      </main>
      <Footer />
    </>
  );
};

const PartnersLayout = () => {
  return (
    <>
      <Header />
      <main>
        <PartnersPage />
      </main>
      <Footer />
    </>
  );
};

const PrivacyLayout = () => {
  return (
    <>
      <Header />
      <main>
        <PrivacyPage />
      </main>
      <Footer />
    </>
  );
};

const BlogListLayout = () => (
  <><Header /><main><BlogListPage /></main><Footer /></>
);

const BlogArticleLayout = () => (
  <><Header /><main><BlogArticlePage /></main><Footer /></>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/patient-billing" element={<PatientBillingLayout />} />
          <Route path="/erp-crm" element={<ErpCrmLayout />} />
          <Route path="/data-science" element={<DataScienceLayout />} />
          <Route path="/industries/:slug" element={<IndustrySubPage />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/about" element={<AboutLayout />} />
          <Route path="/careers" element={<CareersLayout />} />
          <Route path="/partners" element={<PartnersLayout />} />
          <Route path="/privacy" element={<PrivacyLayout />} />
          <Route path="/blog" element={<BlogListLayout />} />
          <Route path="/blog/:slug" element={<BlogArticleLayout />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
